import React, { useEffect, useState } from 'react';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/content';

/**
 * Sticky bottom CTA. Becomes visible as soon as the hero CTA
 * (element with id="hero-cta-anchor") has scrolled out of view.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta-anchor');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-ink/95 px-3 pb-3 pt-3 backdrop-blur transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} style={{
    paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom))'
  }} data-id="element-34" data-mp="bprejgy5e7mi">
      <a href={CHECKOUT_URL} tabIndex={visible ? 0 : -1} aria-hidden={!visible} className="mx-auto flex w-full max-w-xl animate-shake items-center justify-center gap-2 rounded-xl bg-ember px-4 py-3.5 text-center text-sm font-extrabold uppercase tracking-wide text-white shadow-[0_6px_0_0_#a83f00] transition-[background-color] duration-150 ease-out hover:bg-[#ff7d1f] sm:text-base" data-id="element-35" data-mp="2f4ai7cwye0lb">
        <ZapIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="1wf46i9uku990" />
        <span className="leading-tight" data-id="element-37" data-mp="1iebd5sg0hk7h">Get instant access — {PRICE.today}</span>
      </a>
    </div>;
}